export default "__VITE_ASSET__Vo26YFVJ__"